import { Box, Card, CardContent, Container, Typography } from "@mui/material";
import {
  backenIcons,
  frontendIcons,
  devOpsIcons,
} from "../common/TechnologyIcons";

const Skills = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        maxWidth: 1200,
        gap: 4,
        p: 4,
        boxSizing: "border-box",
        backgroundColor: "#f5f5f5",
        margin: "0 auto",
      }}
    >
      <Box
        component="h2"
        sx={{
          textAlign: "center",
          mb: 2,
          fontWeight: 800,
          fontSize: { xs: 24, sm: 32 },
          letterSpacing: 1,
          color: "#000",
          textShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        Skills
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: "stretch",
          width: "100%",
          gap: 4,
        }}
      >
        <Card
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            boxShadow: 3,
            borderRadius: 3,
            bgcolor: "#fff",
            minWidth: 320,
            maxWidth: 480,
          }}
        >
          <CardContent sx={{ mt: 5 }}>
            <Typography variant="h5" align="center" gutterBottom>
              Frontend
            </Typography>
            <Container
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
                mt: 2,
                maxWidth: "800px",
                margin: "1rem auto",
              }}
            >
              {frontendIcons.map((icon, idx) => (
                <Box
                  key={idx}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mb={2}
                >
                  <img
                    src={icon.image}
                    alt="tech icon"
                    style={{ width: 64, height: 64, margin: "12px" }}
                  />
                  <Typography variant="body2" align="center">
                    {icon.label}
                  </Typography>
                </Box>
              ))}
            </Container>
          </CardContent>
        </Card>
        <Card
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            boxShadow: 3,
            borderRadius: 3,
            bgcolor: "#fff",
            minWidth: 320,
            maxWidth: 480,
          }}
        >
          <CardContent sx={{ mt: 5 }}>
            <Typography variant="h5" align="center" gutterBottom>
              Backend
            </Typography>
            <Container
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
                mt: 2,
                maxWidth: "800px",
                margin: "1rem auto",
              }}
            >
              {backenIcons.map((icon, idx) => (
                <Box
                  key={idx}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mb={2}
                >
                  <img
                    src={icon.image}
                    alt="tech icon"
                    style={{ width: 64, height: 64, margin: "12px" }}
                  />
                  <Typography variant="body2" align="center">
                    {icon.label}
                  </Typography>
                </Box>
              ))}
            </Container>
          </CardContent>
        </Card>
      </Box>
      <Card
        sx={{
          width: { xs: "100%", md: "60%" },
          mx: "auto",
          mt: 4,
          boxShadow: 3,
          borderRadius: 3,
          bgcolor: "#fff",
          minWidth: 320,
          maxWidth: 700,
        }}
      >
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            DevOps
          </Typography>
          <Container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              flexWrap: "wrap",
              mt: 2,
              maxWidth: "800px",
              margin: "1rem auto",
            }}
          >
            {devOpsIcons.map((icon, idx) => (
              <Box
                key={idx}
                display="flex"
                flexDirection="column"
                alignItems="center"
                mb={2}
              >
                <img
                  src={icon.image}
                  alt="tech icon"
                  style={{ width: 64, height: 64, margin: "12px" }}
                />
                <Typography variant="body2" align="center">
                  {icon.label}
                </Typography>
              </Box>
            ))}
          </Container>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Skills;
